import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center p-4" dir="rtl">
          <div className="text-center">
            <div className="text-6xl mb-4">🚗</div>
            <h1 className="text-2xl font-bold text-white mb-4">אופס! משהו השתבש</h1>
            <p className="text-gray-400 mb-6">אנא רענן את הדף ונסה שוב</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-amber-500 hover:bg-amber-600 text-black font-bold py-3 px-6 rounded-full transition-all"
            >
              רענן דף
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
